import authReducer from './auth/reducer';
import { combineReducers } from 'redux';
import { RootState } from './root-state';

export default combineReducers<RootState>({
  auth: authReducer,
});
